import { render } from "./NuiDemo.vue?vue&type=template&id=cca2d292&scoped=true"
import script from "./NuiDemo.vue?vue&type=script&lang=js"
export * from "./NuiDemo.vue?vue&type=script&lang=js"

import "./NuiDemo.vue?vue&type=style&index=0&id=cca2d292&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-cca2d292"

export default script